import { IAppState } from 'shared/common/state';
import { TLocation } from 'shared/types/location';

export const selectCurrentLocation = (state: IAppState): TLocation => state.currentLocation;
